export class Boletocolab{
    IDColaborador: string;
    Fecha_ini: string;
    Fecha_fin: string;
    cantidad: number;
}